import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'fast-text-encoding';
import React from 'react';
import { TrackJS } from 'trackjs';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'typeface-open-sans';
import './i18n';

if (process.env.NODE_ENV !== 'production') {
  const { default: axe } = require('@axe-core/react');
  axe(React, ReactDOM, 1000);
}

if (window.location.host.indexOf('localhost') !== 0) {
  TrackJS.install({
    token: process.env.REACT_APP_TRACKJS_TOKEN,
    application: process.env.REACT_APP_TRACKJS_APPLICATION,
  });
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
